/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Cmspage_Place_Group1Inputs */

const vi_cmspage_place_group1 = /** @type {(inputs: Cmspage_Place_Group1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nhóm sản phẩm "${i?.slug}"`)
};

/**

* @param {Cmspage_Place_Group1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_place_group1 = /** @type {((inputs: Cmspage_Place_Group1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Place_Group1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_place_group1(inputs)
});
export { cmspage_place_group1 as "cmsPage_place_group" }